// We add this duration to both the beginning of the slice and the end of the slice
// so that we have some overlap when joining slices together.
export const slicePaddingSeconds = 5;

// The front-end will request transcription for _n_ seconds ahead of the current time.
export const frontendLookaheadSeconds = 30;

export type SliceRange = {
  startTime: number;
  endTime: number;
};

export function getSliceRangeForMinute(minuteIndex: number): SliceRange {
  return {
    startTime: Math.max(0, minuteIndex * 60 - slicePaddingSeconds),
    endTime: (minuteIndex + 1) * 60 + slicePaddingSeconds,
  };
}

export function getMinuteForSecond(second: number): number {
  return Math.floor(second / 60);
}

export function getSliceRangeForTimeRange(
  startTime: number,
  endTime: number
): SliceRange[] {
  let startMinute = getMinuteForSecond(startTime);
  let endMinute = getMinuteForSecond(endTime);

  if (startTime < startMinute * 60 + slicePaddingSeconds) {
    if (startMinute > 0) {
      startMinute -= 1;
    }
  }

  if (endTime > (endMinute + 1) * 60 - slicePaddingSeconds) {
    endMinute += 1;
  }

  const minuteRange: number[] = Array.from(
    { length: endMinute - startMinute + 1 },
    (_, i) => i + startMinute
  );

  return minuteRange.map((minute) => getSliceRangeForMinute(minute));
}
